import React from 'react'
import { Box, Stack, IconButton, Typography, Grid2 as Grid, List, TableCell, TableContainer, Table, TableBody, TableRow, ListItem, ListItemText,TableHead } from '@mui/material'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { AccordionSummary, AccordionDetails, TextField, Button, Link, Modal } from '@mui/material'
import CustomAccordion from '../../components/Accordian/accordian'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetStatesQuery, useAddNoteToLedgerMutation, useGetOperatorGuidesQuery, useAddSMSMutation } from '../../api/endpoints/apiConfig';
import { useState } from 'react';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from '@mui/material/CircularProgress';
type Props = {}
interface MerchandisedItem {
    id: string | number;
    name: string;
    quantity: number;
  }
  
const RentalConfirmation = (props: Props) => {
    // const { facilityId, externalId } = useParams<{ facilityId: string; externalId: string }>();
    const [addNoteToLedger, { isLoading }] = useAddNoteToLedgerMutation();
    const [PostSMS] = useAddSMSMutation();
    const { data: statesData } = useGetStatesQuery();
    const [note, setNote] = useState('');
    const [issmsloading, setissmsloading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    // Extract facilityId and rented from location state (if passed)
   // const { facilityId: stateFacilityId, rentData, result,merchandaisedata  } = location.state || {};
   const { facilityId: stateFacilityId, rentData, result, merchandaisedata = [] as MerchandisedItem[],  } = location.state || {};
    const { cost } = location.state || {};
    const numericFacilityId = Number(stateFacilityId);
    const totalQuantity = merchandaisedata?.reduce((sum: any, item: { quantity: any; }) => sum + item.quantity, 0);
    //Add Notes for the Ledger id
    const numericLedgerId = Number(sessionStorage.getItem('externalLedgerId'));
    const esignURL = sessionStorage.getItem('esignURL');
    const signaturePackageToken = sessionStorage.getItem('signaturePackageToken');
    const signaturePackageId = sessionStorage.getItem('signaturePackageId');
    const firstName = sessionStorage.getItem('FirstName') || '';
    const lastName = sessionStorage.getItem('LastName') || '';
    const agent = `${firstName} ${lastName}`.trim(); // Concatenate FirstName and LastName
    // Check if values exist and convert to string before sanitizing
    const sanitizedMonthlyRate = parseFloat((rentData.MonthlyRate || '0').toString().replace(/[^0-9.]/g, '')) || 0;
    const sanitizedInsurance = parseFloat((rentData.Insurance || '0').toString().replace(/[^0-9.]/g, '')) || 0;
    // Calculate monthly cost
    const monthlyCost = sanitizedMonthlyRate + sanitizedInsurance;
    const operatorId = sessionStorage.getItem('operatorId');
    const { data: FacilityOperatorAlerts } = useGetOperatorGuidesQuery(operatorId ? parseInt(operatorId) : 0);
    const OperatorAlert = FacilityOperatorAlerts?.guides || [];
    // Function to format a number as currency
    const formatCurrency = (amount: number | string): string => {
        // If the amount is already a formatted string, return it directly
        if (typeof amount === 'string' && amount.startsWith('$')) {
            return amount; // Return the already formatted currency string
        }
        // Ensure amount is a number
        const number = parseFloat(String(amount)); // Convert to string first
        // Return formatted currency string or '$0.00' if not a valid number
        return isNaN(number) ? '$0.00' : `$${number.toFixed(2)}`;
    };
    // Transform the API response to match the format of { label: state name }
    const state = statesData?.states.map((state) => ({
        Id: state.abbreviation,
        label: state.name,
    })) || [];
    const customerStateName = state.find(item => item.Id === rentData.customerinfostate)?.label || 'N/A';
    const handleAddNote = async () => {
        try {
            const response = await addNoteToLedger({
                facilityId: numericFacilityId,
                ledgerId: numericLedgerId,
                note,
                agent,
            }).unwrap();
            if (response.status === 1) {
                setNote(''); // Clear the note after successful submission
                toast.success("Notes Successfully Added"); // Open the toast message
            }
        } catch (err) {
            toast.error('Failed to add note');
        }
    };
    const handleDone = () => {
        sessionStorage.removeItem('externalLedgerId');
        sessionStorage.removeItem('esignURL');
        navigate(`/Dashboard/${numericFacilityId}`);
    };


    const formatDate = (date: string | number | Date): string => {

        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // Parse the date as UTC using dayjs.utc()
        const parsedDate = dayjs.utc(date); // Use dayjs.utc() for UTC parsing

        const day = parsedDate.date(); // Get the UTC day
        const month = months[parsedDate.month()]; // Get the UTC month (0-indexed)
        const year = parsedDate.year(); // Get the full UTC year

        return `${month} ${day}, ${year}`;
    };

    const removeHtmlTags = (text: string | null | undefined): string => {
        if (!text) {
            return ''; // Return an empty string for null or undefined input
        }

        // Decode any remaining HTML entities like &nbsp; and normalize spaces
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        const decodedText = textArea.value.replace(/\s+/g, ' ').trim();

        return decodedText;
    };

    const [isModal, setIsModal] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");


    const handleClose = () => setIsModal(false);

    const handleOpen = () => {
        let callersNumber = sessionStorage.getItem("incomingPhones") || '';

        // Remove "+1" if it exists
        if (callersNumber.startsWith("+1")) {
            callersNumber = callersNumber.slice(2);
        }

        // Format as XXX-XXX-XXXX
        const formattedNumber = callersNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");

        setIsModal(true);
        setPhoneNumber(formattedNumber);
    };

    const handleCopyEsignUrl = async () => {
        if (esignURL) {
            try {
                await navigator.clipboard.writeText(esignURL);
                toast.success('eSign URL copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy eSign URL:', err);
                toast.error('Failed to copy eSign URL to clipboard');
            }
        } else {
            toast.error('No eSign URL available to copy');
        }
    };
    // SMS api call method
    const AddSMSdata = async () => {


        const xphoneNumber = rentData.customerinfophone;

        // Remove any non-numeric characters (like spaces, dashes, or parentheses)
        const cleanNumber = xphoneNumber.replace(/\D/g, "");

        // Validate that the phone number is exactly 10 digits
        if (cleanNumber.length !== 10) {
            toast.error("Phone number must be 10 digits");
            return;
        }
        setissmsloading(true);
        const data =
        {
            external_ledger_id: result.external_ledger_id,
            esign_url: esignURL,
            signature_package_token: signaturePackageToken,
            signature_package_id: signaturePackageId
        }
        console.log('SMS data to send', data);
        try {
            const response = await PostSMS({
                facilityId: numericFacilityId,
                occupantid: result.external_occupant_id,
                data,
            }).unwrap();
            if (response.status === 1) {
                setissmsloading(false);
                toast.success(response.message);
                handleClose();
            }
            else {
                toast.error(response.message);
                setissmsloading(false);
                setIsModal(true);
            }
        } catch (err) {
            setissmsloading(false);
            setIsModal(true);
            toast.error('Failed to add SMS');

        }
    };

    return (
        <>
            <Stack direction='row' spacing={1} alignItems={'center'} my={3}>
                <IconButton onClick={() => navigate(`/Dashboard/${numericFacilityId}`)}>
                    <ArrowBackRoundedIcon sx={{ color: 'text.secondary' }} />
                </IconButton>
                <Typography variant='h3' color='text.secondary'>
                    Back to facility page
                </Typography>
            </Stack>
            <Box my={2}>
                <CustomAccordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h3" color="text.secondary">Call Script
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            color="text.primary"
                            textAlign={'left'}
                            dangerouslySetInnerHTML={{ __html: removeHtmlTags(rentData.ScriptValue || OperatorAlert[0]?.facility_page_script || '') }}
                        />
                        {/* <Typography color="text.primary" textAlign={'center'}>{rentData.ScriptValue}</Typography> */}
                    </AccordionDetails>
                </CustomAccordion>
            </Box>
            {/* Confirmation details */}
            <Box my={2}>
                <CustomAccordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h3" color="text.secondary"> Details Confirmation
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails >
                        <Box py={1}></Box>
                        <Grid container spacing={3} >
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Typography mb={2} variant='h4' color='text.secondary'>Rental Details</Typography>
                                <Grid container spacing={0.5} columns={12}>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Unit Size' secondary={rentData.UnitSize || 'N/A'} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Features:' secondary={rentData.Features || 'N/A'} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Monthly Rate:' secondary={`${formatCurrency(rentData.MonthlyRate)}`} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText
                                                    primary='Promotion:'
                                                    secondary={rentData.selectedMonth === 'No Promo' ? '' : (rentData.Promotion || 'N/A')}
                                                />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Promotion Start:"
                                                    secondary={rentData.selectedMonth || 'N/A'}
                                                />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Promotion Start Date:"
                                                    secondary={
                                                        rentData.selectedMonth === 'Next Month'
                                                            ? formatDate(new Date(new Date().setMonth(new Date().getMonth() + 1, 1))) // Calculate first of next month
                                                            : rentData.selectedMonth === 'No Promo' ?
                                                                'N/A'
                                                                : formatDate(rentData.start_date)
                                                    }
                                                />
                                            </ListItem>
                                        </List>
                                    </Grid>


                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Unit Number:' secondary={result.unit_name || 'N/A'} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Access Code:' secondary={result.gate_code || 'N/A'} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Move-in Date:' secondary={
                                                    rentData.start_date
                                                        ? formatDate(rentData.start_date)
                                                        : 'N/A'
                                                } />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                     <Grid size={6}>
                                     </Grid>                                
                                     <Grid size={6}>
                                         <List>
                                             <ListItem sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                                 <ListItemText primary='Lease' />
                                                      <Button
                                                          variant="contained"
                                                          color="primary"
                                                          onClick={handleCopyEsignUrl}
                                                          sx={{
                                                              borderRadius: "20px", // Oval shape
                                                              height: "36px", // Reduce height
                                                              px: 1, // Adjust padding
                                                              minWidth: "120px", // Fixed minimum width
                                                              maxWidth: "200px", // Maximum width to prevent overflow
                                                              width: "auto", // Auto width
                                                              flexShrink: 0, // Prevent shrinking
                                                              textTransform: 'none', // Disable uppercase
                                                          }}
                                                      >
                                                          Copy eSign URL
                                                      </Button>
                                                </ListItem>
                                            </List>
                                    </Grid>
                                    <Grid size={6}>
                                         <List>
                                             <ListItem sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                                 <ListItemText primary='&nbsp;' />
                                                      <Button
                                                          variant="contained"
                                                          color="primary"
                                                          onClick={handleOpen}
                                                          sx={{
                                                              borderRadius: "20px", // Oval shape
                                                              height: "36px", // Reduce height
                                                              px: 1, // Adjust padding
                                                              minWidth: "120px", // Fixed minimum width
                                                              maxWidth: "200px", // Maximum width to prevent overflow
                                                              width: "auto", // Auto width
                                                              flexShrink: 0, // Prevent shrinking
                                                              textTransform: 'none', // Disable uppercase
                                                          }}
                                                      >
                                                          Send Text Msg
                                                      </Button>
                                             </ListItem>
                                         </List>
                                     </Grid>


                                    <Modal
                                        open={isModal}
                                        onClose={(event, reason) => {
                                            if (reason === "backdropClick" || reason === "escapeKeyDown") return;
                                            handleClose();
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: 500,
                                                bgcolor: "background.paper",
                                                border: "2px solid #000",
                                                boxShadow: 24,
                                                p: 4,
                                                borderRadius: "8px",
                                                textAlign: "center",
                                            }}
                                        >
                                            {/* Close Icon */}
                                            <IconButton
                                                onClick={handleClose}
                                                sx={{ position: "absolute", top: 8, right: 8 }}
                                            >
                                                <CloseIcon />
                                            </IconButton>

                                            {/* Modal Title & Subtitle */}
                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                Send the link to sign the lease.
                                            </Typography>
                                            <Typography variant="body2" sx={{ mb: 3 }}>
                                                Text message will be sent to this phone number
                                            </Typography>

                                            {/* Input Field */}
                                            <TextField
                                                fullWidth
                                                label="Phone Number"
                                                variant="outlined"
                                                value={rentData.customerinfophone}
                                                inputProps={{ maxLength: 12, readOnly: true }}
                                                sx={{ mb: 3 }}
                                            />

                                            {/* Buttons */}
                                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                                <Button variant="contained" color="error" onClick={handleClose}>
                                                    Cancel
                                                </Button>
                                                <Button variant="contained"
                                                    color="success"
                                                    onClick={AddSMSdata}
                                                    disabled={issmsloading}
                                                >
                                                    {issmsloading ? <CircularProgress size={24} color='inherit' /> : 'Send SMS'}

                                                </Button>
                                            </Box>
                                        </Box>
                                    </Modal>
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Box mb={2} p={2} bgcolor={'common.white'} borderRadius={2} border={'1px solid #000'} borderColor={'divider'} >
                                    <Typography mb={2} color='text.secondary' variant='h3' fontWeight={700}>Transaction Details</Typography>
                                    <TableContainer component={Box}>
                                        <Table sx={{ maxWidth: '100%' }} aria-label="Transaction Detail">
                                            <TableBody sx={{
                                                '& .MuiTableCell-root': { borderBottom: 'none', padding: '12px' }, '& .MuiTableRow-root:last-child .MuiTableCell-root': {
                                                    borderTop: '1px solid',
                                                    borderColor: 'divider'
                                                }
                                            }}>
                                                <TableRow>
                                                    <TableCell align="left">
                                                        <Typography color="text.secondary" fontWeight={500}>First Month Rent</Typography>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Typography>
                                                            {formatCurrency(rentData.FirstMonthRent)}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align="left">
                                                        <Typography fontWeight={500}>Promotion</Typography>
                                                        <Typography component={'i'} color='error.light'>
                                                            {rentData.selectedMonth === 'No Promo' ? '' : (rentData.Promotion || '')}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                                {/* <TableRow>
                                                    <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Administrative Fee</Typography></TableCell>
                                                    <TableCell align="right"><Typography>{`$${rentData.AdministrativeFee || '0'}`}</Typography></TableCell>
                                                </TableRow> */}
                                                {cost?.fees?.map((fee: { name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; cost: any; }, index: React.Key | null | undefined) => (
                                            <TableRow key={index}>
                                                <TableCell align="left">
                                                    <Typography color="text.secondary" fontWeight={500}>
                                                        {fee.name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography>
                                                        {`$${parseFloat(fee.cost || "0").toFixed(2)}`}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                                <TableRow>
                                                    <TableCell align="left" ><Typography color='text.secondary' fontWeight={500}>Insurance</Typography>
                                                        <Typography component={'i'} >Tenant Protection Plan</Typography>
                                                    </TableCell>
                                                    <TableCell align="right"><Typography >{`$${rentData.InsuranceValue.toFixed(2) || '0.00'}`}</Typography></TableCell>
                                                </TableRow>

                                                {totalQuantity !==0 &&(rentData?.merchandfee) !== 0 ? (<TableRow>
                                                    <TableCell align="left" ><Typography color='text.secondary' fontWeight={500}>Merchandise</Typography>

                                                    </TableCell>
                                                    <TableCell align="right"><Typography>{`$${parseFloat(rentData?.merchandfee || "0").toFixed(2)}`}</Typography></TableCell>
                                                </TableRow>) : ""}

                                                <TableRow >
                                                    <TableCell align="left" ><Typography color='text.secondary' fontWeight={500}>Rent Tax</Typography>

                                                    </TableCell>
                                                    <TableCell align="right"><Typography >{`$${rentData.RentTax.toFixed(2) || '0'}`}</Typography></TableCell>
                                                </TableRow>

                                                {totalQuantity !==0 && (rentData?.merchandfee) !== 0 ? (<TableRow>
                                                    <TableCell align="left" ><Typography color='text.secondary' fontWeight={500}>Sales Tax</Typography>

                                                    </TableCell>
                                                    <TableCell align="right"><Typography>{`$${parseFloat(rentData?.salestax || "0").toFixed(2)}`}</Typography></TableCell>
                                                </TableRow>) : ""}
                                                <TableRow>
                                                    <TableCell align="left"><Typography color='text.secondary' fontWeight={700} variant='h3'>Due Now</Typography></TableCell>
                                                    <TableCell align="right"><Typography color='text.secondary' fontWeight={700} variant='h3'>{`$${rentData.Move_in_cost.toFixed(2) || '0.00'}`}</Typography></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Box mb={2} p={2} bgcolor={'common.white'} borderRadius={2} border={'1px solid #000'} borderColor={'divider'}>
                                    <Typography mb={2} color='text.secondary' variant='h3' fontWeight={700}>Recurring Monthly Cost</Typography>
                                    <TableContainer component={Box}>
                                        <Table sx={{ maxWidth: '100%' }} aria-label="Transaction Detail">
                                            <TableBody sx={{
                                                '& .MuiTableCell-root': { borderBottom: 'none', padding: '12px' }, '& .MuiTableRow-root:nth-of-type(4) .MuiTableCell-root': {
                                                    borderTop: '1px solid',
                                                    borderColor: 'divider'
                                                }
                                            }}>
                                                <TableRow>
                                                    <TableCell align="left"><Typography color='text.secondary' fontWeight={500}>Monthly Rent</Typography></TableCell>
                                                    <TableCell align="right"><Typography>{formatCurrency(rentData.MonthlyRate)}</Typography></TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" ><Typography color='text.secondary' fontWeight={500}>Insurance</Typography>
                                                        <Typography component={'i'} >Tenant Protection Plan</Typography>
                                                    </TableCell>
                                                    <TableCell align="right"><Typography >{`${formatCurrency(rentData.Insurance.toFixed(2) || '0.00')}`}</Typography></TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left">
                                                        <Typography color='text.secondary' fontWeight={700} variant='h3'>Monthly Cost</Typography>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Typography color='text.secondary' fontWeight={700} variant='h3'>{`$${monthlyCost.toFixed(2)}`}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                                {totalQuantity !==0 && ( <Box mt={2} p={2} bgcolor={'common.white'} borderRadius={2} border={'1px solid #000'} borderColor={'divider'}>
                                   <Typography mb={2} color='text.secondary' variant='h3' fontWeight={700}>
                                       Merchandise List
                                   </Typography>
                                   <TableContainer component={Box}>
                                       <Table sx={{ maxWidth: '100%' }} aria-label="Merchandise List">
                                           <TableHead>
                                               <TableRow sx={{ bgcolor: 'grey.200' }}>
                                                   <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
                                                   <TableCell align="right" sx={{ fontWeight: 700 }}>Quantity</TableCell>
                                               </TableRow>
                                           </TableHead>
                                           <TableBody>
                                           {merchandaisedata
  .filter((item: MerchandisedItem) => item.quantity > 0)
  .map((item: MerchandisedItem) => (
    <TableRow key={item.id}>
      <TableCell>{item.name}</TableCell>
      <TableCell align="right">{item.quantity}</TableCell>
    </TableRow>
  ))}

                               </TableBody>
                               
                                       </Table>
                                   </TableContainer>
                               </Box> )}

                            </Grid>

                        </Grid>
                    </AccordionDetails>
                </CustomAccordion>
            </Box>
            {/* Customer Information */}
            <Box my={2}>
                <CustomAccordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h3" color="text.secondary">Customer Information</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Typography mb={2} variant='h4' color='text.secondary'>Customer Details</Typography>
                                <List>
                                    <ListItem>
                                        <ListItemText primary='First Name' secondary={rentData.customerinfofirstname || 'N/A'} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary='Phone' secondary={rentData.customerinfophone || 'N/A'} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary='City' secondary={rentData.customerinfocity || 'N/A'} />
                                    </ListItem>

                                </List>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <List>
                                    <ListItem sx={{ mt: 4 }}>
                                        <ListItemText primary='Last Name' secondary={rentData.customerinfolastname || 'N/A'} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary='Address' secondary={rentData.customerinfoaddress1 || 'N/A'} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary='State' secondary={customerStateName || 'N/A'} />
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <List>
                                    <ListItem sx={{ mt: 4 }}> {/* Margin-top added here to shift downwards */}
                                        <ListItemText primary="Email" secondary={rentData.customerinfoemail || 'N/A'} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Address-2" secondary={rentData.customerinfoaddress2 || 'N/A'} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Postal Code" secondary={rentData.customerinfoPostalcode || 'N/A'} />
                                    </ListItem>
                                </List>
                            </Grid>

                        </Grid>
                    </AccordionDetails>
                    <AccordionDetails>
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Typography mb={2} variant='h4' color='text.secondary'>Emergency Contact</Typography>
                                <List>
                                    <ListItem>
                                        <ListItemText primary='First Name' secondary={rentData.emergencyContactfirstname || 'N/A'} />
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <List>
                                    <ListItem sx={{ mt: 4 }}>
                                        <ListItemText primary='Last Name' secondary={rentData.emergencyContactlastname || 'N/A'} />
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <List>
                                    <ListItem sx={{ mt: 4 }}>
                                        <ListItemText primary='Phone' secondary={rentData.emergencyContactphone || 'N/A'} />
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextField
                            label="Add Note"
                            placeholder="Enter note here"
                            multiline
                            fullWidth
                            rows={4}
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            variant="outlined"
                            sx={{ mt: 2 }}
                        />
                        <Button
                            onClick={handleAddNote}
                            disabled={isLoading}
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                        >
                            {isLoading ? 'Adding...' : 'Add Note'}
                        </Button>
                        <Link
                            onClick={handleDone}
                            sx={{ color: '#2400cb', cursor: 'pointer', ml: 132, mt: 1, fontStyle: 'italic' }}
                        >
                            Done
                        </Link>
                    </AccordionDetails>
                </CustomAccordion>
            </Box>

        </>
    )
}

export default RentalConfirmation
